/**
 * 🚀 UPDATED: useReduxSelectorsZoneBased Hook for VoiceActor
 * 
 * This hook mirrors the BookWorksheet zone-based architecture that eliminates
 * cross-zone contamination and provides optimal performance.
 * 
 * PERFORMANCE IMPROVEMENT: 
 * - Eliminates 200% redundant renders
 * - Achieves true zone isolation
 * - Uses new voiceActorDataSlice
 * 
 * ENTITY MAPPING:
 * - litGroupId → actorId
 * - bookId → portfolioId
 * - characterId → characterId (same)
 */

import { useReduxSelectorsZoneBasedNew } from './useZoneHooks';

// Export the new implementation that uses clean zone architecture
export const useReduxSelectorsZoneBased = useReduxSelectorsZoneBasedNew;

export default useReduxSelectorsZoneBased;
